<form [formGroup]="grp">

  <div fxFlex class="space-bottom" fxLayout="column">

    <div fxLayout="row" fxLayoutGap="20px">
      <div fxFlex fxLayout="column" fxLayoutGap="5px">
        @if (captureToolType != receiptToolTypes.UniqueSafebox) {
          <mat-form-field fxFlex [class.readonly]="readonly">
            <mat-label>Scheme</mat-label>
            @if (!readonly) {
              <mat-select [formControl]="grp['controls'].schemeId">
                @for (s of schemes; track s) {
                  <mat-option [value]="s.id">{{ s.name || '[No Scheme Name]' }}</mat-option>
                }
              </mat-select>
            } @else {
              <input [readonly]="readonly" type="text" matInput placeholder="" [value]="currentScheme?.name"
                autocomplete="off">
            }
          </mat-form-field>
        }

        <mat-form-field fxFlex [class.readonly]="readonly">
          <mat-label>Title</mat-label>
          <input type="text" [readonly]="readonly" matInput placeholder="" [formControl]="grp['controls'].title"
            autocomplete="off">
          @if (grp.get('title').touched && !grp.get('title').valid) {
            <mat-error>Please enter a title for this
            step</mat-error>
          }
        </mat-form-field>

        <div fxFlex fxLayout="row" fxLayoutGap="10px">
          <mat-form-field fxFlex [class.readonly]="readonly">
            <mat-label>{{placeHolderCompleteStep}}</mat-label>
            <input type="number" [readonly]="readonly" matInput placeholder=""
              [formControl]="grp['controls'].maxStampCount" step="1" autocomplete="off">
            @if (grp.get('maxStampCount').touched && !grp.get('maxStampCount').valid) {
              <mat-error>Please enter
                number of {{punchCardCampaignService.strategyType === 'Points' ? 'points' : 'stamps'}} to complete the
              step</mat-error>
            }
          </mat-form-field>

          <mat-form-field fxFlex [class.readonly]="readonly">
            <mat-label>Repeat step</mat-label>
            <input matInput type="number" [readonly]="readonly" placeholder=""
              [formControl]="grp['controls'].restartLimit" maxlength="100" autocomplete="off" step="1">
            @if (grp.get('restartLimit').touched && !grp.get('restartLimit').valid) {
              <mat-error>Please enter number
              of times to repeat this step</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxFlex></div>

      </div>
      <div fxLayout="column" fxFlex fxFlexFill>
        <div fxLayout="row" class="reward-select">
          <mat-form-field fxFlex>
            <mat-label>Product reward</mat-label>
            <mat-select [formControl]="grp['controls'].completeReward" [compareWith]="compareRewardData"
              (selectionChange)="onRewardSelected($event.value)" placeholder="">
              <mat-option [value]="null">(None)</mat-option>
              @for (product of rewardProductsOptions; track product) {
                <mat-option [value]="product"
                [matTooltip]="product.productSlug">{{ product.rewardTitle }}</mat-option>
              }
            </mat-select>
            @if ((grp.touched && !grp.get('completeReward').valid)) {
              <mat-error>Please select the complete step
              reward</mat-error>
            }
          </mat-form-field>
          <div fxFlex="40px">
            @if (!hasProductReward(grp)) {
              <button fxFlex fxFlexAlign="end" (click)="onAddRewardProduct(grp)"
                mat-icon-button color="primary" type="button"
                matTooltip="Add reward product"><mat-icon>add</mat-icon></button>
              }
              @if (hasProductReward(grp)) {
                <button fxFlex fxFlexAlign="end" (click)="onRemoveRewardProduct(grp)"
                  mat-icon-button color="primary" type="button"
                  matTooltip="Delete reward product"><mat-icon>delete</mat-icon></button>
                }
              </div>
            </div>
            <!-- COINS -->
            @if (allowCoins) {
              <div fxLayout="row">
                <mat-form-field fxFlex>
                  <mat-label>Coins reward</mat-label>
                  <mat-select [compareWith]="compareCoinRewardFn" placeholder="" formControlName="coinReward">
                    <mat-option [value]="null"></mat-option>
                    @for (coinReward of coinRewardOptions; track coinReward) {
                      <mat-option [value]="coinReward">{{ coinReward.coins }} coins
                      reward</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <!-- STAMPS -->
            @if (allowStamps) {
              <div fxLayout="row">
                <mat-form-field fxFlex>
                  <mat-label>Stamps reward</mat-label>
                  <mat-select [compareWith]="compareStampRewardFn" placeholder="" formControlName="stampReward">
                    <mat-option [value]="null"></mat-option>
                    @for (stampReward of stampRewardOptions; track stampReward) {
                      <mat-option [value]="stampReward">{{ stampReward.stamps }}
                      stamps reward</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <!-- POINTS -->
            @if (allowPoints) {
              <div fxLayout="row">
                <mat-form-field fxFlex>
                  <mat-label>Points reward</mat-label>
                  <input type="number" matInput placeholder="" formControlName="coinReward" autocomplete="off" min="0">
                </mat-form-field>
              </div>
            }
            <div fxLayout="row">
              <!-- Col right -->
              <div fxFlex fxLayout="column" fxLayoutAlign="center start">

                <!-- <div class="section-title">Complete Reward</div> -->
                @if (grp.value['completeReward']; as product) {
                  <div fxLayout="column" fxLayoutAlign="start">
                    <div fxFlex fxLayout="row" fxLayoutGap="20px">
                      @if (product.rewardPhotoUrl) {
                        <div class="reward-photo">
                          <lib-photo [url]="product.rewardPhotoUrl" [width]="'153px'" [height]="'153px'"
                          [radius]="'10px'"></lib-photo>
                        </div>
                      }
                      <div fxFlex fxLayout="column" fxLayoutAlign="start">
                        @if (product.rewardTitle) {
                          <div class="info-v">
                            <div class="lbl">Reward title</div>
                            <div class="val" [innerHTML]="product.rewardTitle"></div>
                          </div>
                        }
                        @if (product.rewardDescription) {
                          <div class="info-v">
                            <div class="lbl">Reward description</div>
                            <div class="val" [innerHTML]="product.rewardDescription"></div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div fxFlex>
          <app-campaign-banner [editable]="false" [formControl]="grp['controls'].banner"></app-campaign-banner>
        </div>

      </div>
    </form>
